
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/give/[[...slug]]",
      function () {
        return require("private-next-pages/give/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/give/[[...slug]]"])
      });
    }
  